import React, { Component } from 'react';
import TimeSelect from '../../../common/TimeSelect';

class TimesItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: Boolean(props.value),
    };
  }

  handleClick = (e) => {
    // e.preventDefault()
    this.setState({ showTimes: !this.state.showTimes})
  }

  handleChange = (e) => {
    // e.preventDefault()
    this.setState({ isActive: !this.state.isActive })
    this.props.changeDayHandler(this.props.day)
  }


  render() {
    const { title, value, day, first, changeTimeHandler } = this.props;
    const { isActive, showTimes } = this.state;
    return (
      <div className="times_item">
        <label className="switch select-time__switch" htmlFor={`geozone-day-${day}`} style={{ margin: ' auto 15px auto 0' }}>
          <input
            id={`geozone-day-${day}`}
            onChange={this.handleChange}
            type="checkbox"
            checked={isActive}
          />
          <span className="slider select-time__slider slider">{title}</span>
        </label>
        { showTimes && (
          <div style={{ flex: 1, display: 'flex', padding: '10px 15px 10px 0px', borderTop: first ? 'none' : '1px solid #f2f2f2' }}>
            <span style={{ margin: 'auto 0', lineHeight: '30px', opacity: isActive ? 1 : .5 }}>{title}</span>
            <div style={{ marginLeft: 'auto', display: 'flex', opacity: value ? 1 : 0 }}>
              <TimeSelect key="from" value={value ? value.from : null} defaultValue="00:00:00" changeHandler={newValue => changeTimeHandler(day, 'from', newValue)} />
              <span style={{ margin: 'auto 5px' }}>–</span>
              <TimeSelect key="to" value={value ? value.to : null} defaultValue="23:59:59" changeHandler={newValue => changeTimeHandler(day, 'to', newValue)} />
            </div>
          </div>
        )}
        
      </div>
    );
  }
}

TimesItem.propTypes = {};
TimesItem.defaultProps = {};

export default TimesItem;



// WEBPACK FOOTER //
// ./src/components/Modal/GeozonesModal/Times/TimesItem.js